import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { mprService } from "../../../Services";
import { mprActions } from '../../../Actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';


const Form = ({ proposal, previousMpr, mpr }) => {
    const [submitted, setSubmitted] = useState(false);
    const [input, setInput] = useState({executive_summary: mpr?.executive_summary || '', potential: mpr?.potential || '', proposed_plan: mpr?.proposed_plan ? JSON.parse(mpr.proposed_plan, true) : [], work_progress: mpr?.work_progress || '', link: mpr?.link || ''});
    const [file, setFile] = useState('');
    const [fileSize, setFileSize] = useState(true);
    const dispatch = useDispatch();
    const [disableSubmission, setDisableSubmission] = useState(mpr?.submit_status === 1 ? true : false);
    const [disableInput, setDisableInput] = useState(mpr?.submit_status === 1 ? true : false);

    useEffect(() => {
        if(!disableInput && previousMpr) {
            setDisableInput(previousMpr?.executive_summary !== null ? true : false);
            setInput({...input, executive_summary: previousMpr?.executive_summary || '', potential: previousMpr?.potential || '', proposed_plan: previousMpr?.proposed_plan ? JSON.parse(previousMpr.proposed_plan, true) : []});
        }
    }, []);

    const handleChange = (e) => {
        setFile(e.target.files);
        setInput({...input, [e.target.name]: e.target.value });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        setFileSize(true);
        setSubmitted(true);
        submitForm();
    }
    const submitForm = () => {
        const formData = new FormData();
        formData.append('submit_status', 1);
        formData.append('app_id', proposal.id);
        formData.append('mpr_id', mpr.id);
        formData.append('month_number', mpr.month_number);

        for (const [key, value] of Object.entries(input)) {
            if(key === 'proposed_plan') {
                formData.append(key, JSON.stringify(value));
                continue;
            }
            formData.append(key, value);
        }

        if (file) {
            if(file[0].size > 10240000) {
                setFileSize(false);
                setSubmitted(false);
                return;
            }
            formData.append('doc', file[0]);
        }

        mprService.mprSave(formData).then(res => {
            if (res.status == 1) {
                const mpr = res.data;
                localStorage.setItem("mpr", JSON.stringify(mpr));
                dispatch(mprActions.mpr(mpr));
            }
            setSubmitted(false);
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        });
    }
    // Add Proposed Plan functionality
    const [proposedPlans, setProposedPlans] = useState(
        Array.isArray(input.proposed_plan) ? input.proposed_plan : []
    );

    // Update input.proposed_plan when proposedPlans change
    const updateProposedPlans = (newProposedPlans) => {
        setProposedPlans(newProposedPlans);
        setInput({ ...input, proposed_plan: newProposedPlans });
    };

    const handleProposedPlanChange = (index, field, value) => {
        const updated = proposedPlans.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        updateProposedPlans(updated);
    };

    const addProposedPlan = () => {
        updateProposedPlans([
            ...proposedPlans,
            { milestone: "", duration: "", status: "" }
        ]);
    };

    const removeProposedPlan = (index) => {
        const updated = proposedPlans.filter((_, i) => i !== index);
        updateProposedPlans(updated);
    };
    
    useEffect(() => {
        setProposedPlans(
            Array.isArray(input.proposed_plan) ? input.proposed_plan : []
        );
    }, [input]);
    return (
        <div className="container">
            <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                <div className="form-group mb-3">
                    <label htmlFor="executive_summary">Executive Summary (250 Words) and end deliverable (as mentioned in the proposal in 250 Words) [This will remain the same for all the MPRs]</label>
                    <textarea className="form-control" id="executive_summary" name="executive_summary" rows="3" value={input.executive_summary} onChange={handleChange} disabled={disableInput}></textarea>
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="potential">Potential for upscaling the project & how it is contributing to a larger outcome within the institutions/country/global discourse. (max 250 words)</label>
                    <textarea className="form-control" id="potential" name="potential" rows="3" value={input.potential} onChange={handleChange} disabled={disableInput}></textarea>
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="proposed_plan">Original Proposed Plan as per submitted proposal [Milestones and their duration will be frozen from the first month, and only provide updates in the Status column]</label>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Milestone</th>
                                <th>Duration</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {proposedPlans.length > 0 ? proposedPlans.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <input
                                            className="form-control"
                                            type="text"
                                            value={item.milestone}
                                            onChange={e => handleProposedPlanChange(index, "milestone", e.target.value)}
                                            disabled={disableInput}
                                        />
                                    </td>
                                    <td>
                                        <select
                                            className="form-control"
                                            value={item.duration}
                                            onChange={e => handleProposedPlanChange(index, "duration", e.target.value)}
                                            disabled={disableInput}
                                        >
                                            <option value="">Select Duration</option>
                                            {Array.from({ length: 36 }, (_, i) => i + 1).map(month => (
                                                <option key={month} value={`${month} month${month > 1 ? 's' : ''}`}>
                                                    {month} month{month > 1 ? 's' : ''}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <select
                                            className="form-control"
                                            value={item.status}
                                            onChange={e => handleProposedPlanChange(index, "status", e.target.value)}
                                            disabled={disableSubmission}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="Completed">Completed</option>
                                            <option value="Ongoing">Ongoing</option>
                                            <option value="Lagging">Lagging</option>
                                            <option value="Discontinued">Discontinued</option>
                                        </select>
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => removeProposedPlan(index)}
                                            title="Remove Proposed Plan"
                                            disabled={disableInput}
                                        >
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={4}>No Proposed Plan added.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={addProposedPlan}
                        disabled={disableInput}
                    >
                        Add Proposed Plan
                    </button>
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="work_progress">Work Progress</label>
                    <textarea className="form-control" id="work_progress" name="work_progress" rows="3" value={input.work_progress} onChange={handleChange} disabled={disableSubmission} ></textarea>
                </div>
                <div className="form-group mb-3">
                    <label htmlFor="link">Any other documents link</label>
                    <input type="text" className="form-control" id="link" name="link" value={input.link} onChange={handleChange} disabled={disableSubmission} />
                </div>
                {/* <div className="form-group mb-3">
                    {mpr?.work_progress_doc &&
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+mpr.work_progress_doc} target="_blank" rel="noreferrer" className="mr-2">
                            <FontAwesomeIcon icon={faFileAlt} style={{height: "20px"}} />
                        </a>
                    }
                    <input type="file" className='custom-file-input1' id="customFile" name='work_progress_doc' onChange={handleChange} disabled={disableInput} />
                    {!fileSize && <p style={{color:'red'}}>File size should not be greater than 10MB!</p>}
                </div> */}
                {!disableSubmission &&
                    <button type="submit" className="btn btn-primary">{submitted ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Submit</span>}</button>
                }
            </form>
        </div>
    );
}

export default Form;